import styled from 'styled-components';
import { devices } from '../../constant';

export const PostTitle = styled.div`
    font-size: 4vw;
    text-align: center;
    margin: 60px 20px;

    @media ${devices.tablet} {
        font-size: 8vw;
        margin: 4%;
    }
`;

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    margin-bottom: 8em;
`;
